import { Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";

type TProps = {
  activeTab: string;
  toggleTab: (tabId: string) => void;
};
export const SubjectTabMenu: React.FC<TProps> = ({ activeTab, toggleTab }) => {
  const { t } = useTranslation();
  return (
    <Nav
      pills
      className="animation-nav profile-nav gap-2 gap-lg-3 flex-grow-1"
      role="tablist"
    >
      <NavItem>
        <NavLink
          href="#organizing"
          className={classnames({ active: activeTab === "0" })}
          onClick={() => {
            toggleTab("0");
          }}
        >
          <i className=" ri-book-line d-inline-block d-md-none"></i>{" "}
          <span className="d-none d-md-inline-block">{t("organizing")}</span>
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          href="#questions"
          className={classnames({ active: activeTab === "1" })}
          onClick={() => {
            toggleTab("1");
          }}
        >
          <i className=" ri-book-line d-inline-block d-md-none"></i>{" "}
          <span className="d-none d-md-inline-block">{t("questions")}</span>
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          href="#skills"
          className={classnames({ active: activeTab === "2" })}
          onClick={() => {
            toggleTab("2");
          }}
        >
          <i className=" ri-bar-chart-line d-inline-block d-md-none"></i>{" "}
          <span className="d-none d-md-inline-block">{t("skills")}</span>
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          href="#notes"
          className={classnames({ active: activeTab === "3" })}
          onClick={() => {
            toggleTab("3");
          }}
        >
          <i className=" ri-file-edit-line d-inline-block d-md-none"></i>{" "}
          <span className="d-none d-md-inline-block">{t("notes")}</span>
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          href="#flash-cards"
          className={classnames({ active: activeTab === "4" })}
          onClick={() => {
            toggleTab("4");
          }}
        >
          <i className=" ri-slideshow-4-line d-inline-block d-md-none"></i>{" "}
          <span className="d-none d-md-inline-block">{t("flashCards")}</span>
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          href="#lectures"
          className={classnames({ active: activeTab === "5" })}
          onClick={() => {
            toggleTab("5");
          }}
        >
          <i className=" ri-slideshow-4-line d-inline-block d-md-none"></i>{" "}
          <span className="d-none d-md-inline-block">{t("lectures")}</span>
        </NavLink>
      </NavItem>
    </Nav>
  );
};
